<div class="fc-detail-form">
  <div class="fc-detail-form-header">
    <span class="material-icons fc-detail-form-icon">badge</span>
    <h3 class="fc-detail-form-title">{{ operatorForm.controls.id.value ? 'Edit Operator' : 'Add Operator' }}</h3>
  </div>

  <form [formGroup]="operatorForm" (ngSubmit)="onSubmit()" class="fc-form-grid">
    <input formControlName="id" type="hidden" />

    <mat-form-field appearance="outline">
      <mat-label>Code</mat-label>
      <input matInput formControlName="code" required />
      <mat-error *ngIf="operatorForm.controls?.code?.hasError('required')">Required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" required />
      <mat-error *ngIf="operatorForm.controls?.name?.hasError('required')">Required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Customer</mat-label>
      <mat-select formControlName="customerId" required>
        <mat-option *ngFor="let customer of customers" [value]="customer.id">{{ customer.name }}</mat-option>
      </mat-select>
      <mat-error *ngIf="operatorForm.controls?.customerId?.hasError('required')">Required</mat-error>
    </mat-form-field>

    <div class="fc-form-actions">
      <button type="reset" class="fc-btn fc-btn--ghost" (click)="clear()">Clear</button>
      <button type="submit" class="fc-btn fc-btn--primary" [disabled]="!operatorForm.valid">Save</button>
    </div>
  </form>
</div>
